import SideBarUniversalProductsCatalog from 'components/Page/PageSideBar/SideBarUniversalProductsCatalog/SideBarUniversalProductsCatalog';
export default SideBarUniversalProductsCatalog;
